<template>
  <page-header class="page-header-search">
    <div class="tag-title">
      <h1>
        {{ searchString }}
      </h1>
    </div>
  </page-header>
</template>

<script>
import PageHeader from './PageHeader'

export default {
  name: 'PageHeaderSearch',
  components: { PageHeader },
  props: {
    searchString: { type: String, default: '' }
  },

  data: () => ({}),

  computed: {},

  methods: {}
}
</script>

<style lang="scss">
  .page-header-search {
  }
</style>
